import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import './Chat.css' // Arquivo de estilo
import { CustomPanel, PageHeader, RouteChat } from '../../../../components'
import * as DeliveryHttp from '../../../../services/api/https/deliveries/delivery.http'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import { getUsuarioInfo } from '../../../../services/localstorage/localstorage.service'
import { errorHandler } from '../../../../services/util/error.service'
import { formatIsoDateToLocale } from '../../../../services/util/date.service'

const ChatWeb = ({ dispatch, history }) => {
  const { delivery_id, vehicle_badge, fleet_id, disabled } =
    (history.location && history.location.state) || {}

  return (
    <>
      <PageHeader>
        Chat Tp Drive - {delivery_id ? 'Entrega' : 'Veículo'} -&nbsp;
        <strong>{vehicle_badge}</strong>
      </PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel showBtnNovo={false} onVoltar={history.goBack}>
          <div className="p-grid">
            <div className="p-col-12">
              {delivery_id ? (
                <DeliveryChatHistory dispatch={dispatch} deliveryId={delivery_id} />
              ) : (
                <div style={{ width: '100%', maxWidth: 800, height: '80vh', margin: '10px auto' }}>
                  <RouteChat
                    fleetId={fleet_id}
                    readOnly={Boolean(disabled)}
                    title={`Chat Tp Drive - Veículo - ${vehicle_badge || fleet_id}`}
                  />
                </div>
              )}
            </div>
          </div>
        </CustomPanel>
      </div>
    </>
  )
}

// Modo ENTREGA (legado): somente leitura do histórico antigo.
// O envio por entrega será reimplementado sobre o novo gateway de chat.
function DeliveryChatHistory({ dispatch, deliveryId }) {
  const user = getUsuarioInfo()
  const [messages, setMessages] = useState([])
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    let active = true

    const fetchHistory = async () => {
      dispatch(showLoadingBox('Aguarde...', 'Carregando dados...'))
      try {
        const history = await DeliveryHttp.getChatDelivery(deliveryId)
        if (active) setMessages(history || [])
      } catch (error) {
        dispatch(showMessageBox(null, errorHandler(error)))
      } finally {
        dispatch(hideLoadingBox())
        if (active) setLoaded(true)
      }
    }

    fetchHistory()

    return () => {
      active = false
    }
  }, [deliveryId])

  return (
    <div className="chat-container">
      <div className="chat-messages">
        {messages.map((msg, idx) => (
          <div
            key={idx}
            className="chat-bubble"
            style={
              user.name === msg.nickname
                ? {
                    textAlign: 'end',
                    backgroundColor: '#d9ffc8',
                    justifySelf: 'end',
                  }
                : {
                    textAlign: 'start',
                    justifySelf: 'start',
                  }
            }
          >
            <strong>{msg.nickname}:</strong> <span>{msg.message}</span>
            <div className="chat-date">
              {formatIsoDateToLocale(msg.created_at).toFormat('dd/MM/yyyy HH:mm')}
            </div>
          </div>
        ))}
        {loaded && !messages.length && (
          <div className="chat-empty">Nenhuma mensagem encontrada</div>
        )}
      </div>
      <div className="chat-note">
        O envio de mensagens por entrega está temporariamente indisponível e será reimplementado em
        breve.
      </div>
    </div>
  )
}

export default connect()(withRouter(ChatWeb))
